import axios from 'axios';

export const getEmployeeGroupList = (name: string) => {
  return axios
    .get(`/api/v1/groups?name=${name}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEmployeeGroups = () => {
  return axios
    .get(`/api/v1/tenant/groups`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createEmployeeGroup = (
  name: string,
  email: string,
  role_sale: number,
  role_client: number,
  role_partner: number,
  role_construction: number,
  role_product: number,
  role_accounts: number
) => {
  return axios
    .post(
      `/api/v1/groups`,
      {
        name,
        email,
        role_sale,
        role_client,
        role_partner,
        role_construction,
        role_product,
        role_accounts
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEmployeeGroupListDetails = (id: number) => {
  return axios
    .get(`/api/v1/groups/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteEmployeeGroupById = (id: number) => {
  return axios
    .delete(`/api/v1/groups/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateEmployeeGroup = (
  id: number,
  name: string,
  email: string,
  role_sale: number,
  role_client: number,
  role_partner: number,
  role_construction: number,
  role_product: number,
  role_accounts: number
) => {
  return axios
    .put(
      `/api/v1/groups/${id}`,
      {
        name,
        email,
        role_sale,
        role_client,
        role_partner,
        role_construction,
        role_product,
        role_accounts
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
